<div class="smartphoto-detailed-info-container">
  <bdeo-skeleton-title-text class="status-tag" size="medium"></bdeo-skeleton-title-text>
  <div class="date-container">
    <bdeo-skeleton-body-text margin="false"></bdeo-skeleton-body-text>
    <bdeo-skeleton-body-text margin="false"></bdeo-skeleton-body-text>
  </div>
  <div class="fields-container">
    <div class="fields-label-container">
      <bdeo-skeleton-body-text *ngFor="let i of [1, 2, 3]" margin="false"></bdeo-skeleton-body-text>
    </div>
    <div class="fields-value-container">
      <bdeo-skeleton-body-text *ngFor="let i of [1, 2, 3]" margin="false"></bdeo-skeleton-body-text>
    </div>
  </div>
  <bdeo-divider type="horizontal"></bdeo-divider>
  <div class="fields-container">
    <div class="fields-label-container">
      <bdeo-skeleton-body-text *ngFor="let i of [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]" margin="false"></bdeo-skeleton-body-text>
    </div>
    <div class="fields-value-container">
      <bdeo-skeleton-body-text *ngFor="let i of [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]" margin="false"></bdeo-skeleton-body-text>
    </div>
  </div>
</div>
